import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-editar-cliente',
  templateUrl: './editar-cliente.component.html',
  styleUrls: ['./editar-cliente.component.css']
})
export class EditarClienteComponent implements AfterViewInit, OnInit, OnDestroy{

  estado: any;
  telefonoError: boolean = false;
  clienteId: any;
  errorFinalMessage : string =""; //Mensaje de error
  tiempoEsperaRecarga: number = 60000;
  clienteData: any = [];
  clienteDispositivos: any = [];
  clienteUsuarios: any = [];
  numeroUsuarios: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroUsuarios];
  numeroDispositivos: number = 0;
  pageSizeOptions1: number[] = [5, 10, this.numeroDispositivos];
  razonSocialError: boolean = false;
  nombreComercialError: boolean = false;
  clienteEditado: boolean = false;
  nifError: boolean = false;
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;

  signin: FormGroup = new FormGroup({
    razonSocial: new FormControl('', [Validators.required]),
    nombreComercial: new FormControl('', [Validators.required]),
    iniciales: new FormControl(''),
    nif: new FormControl(''),
    telefono: new FormControl(''),
    personaContacto: new FormControl(''),
    estado: new FormControl()
  });

  displayedColumns: string[] = ['dev_reference','dev_label','operaciones'];
  displayedColumns1: string[] = ['id','email', 'operaciones'];
  dataSource :any;
  dataSource1 :any;

  private clienteSubscription: Subscription | undefined;
  private editarSubscription: Subscription | undefined;

  @ViewChild('sort') sort!: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator;

  @ViewChild('sort1') sort1!: MatSort;
  @ViewChild('paginator1') paginator1!: MatPaginator;

  constructor(private cdRef: ChangeDetectorRef, private router: Router, private userService: UserService,
    private error429: Error429Service){
    this.clienteId = this.getClienteIdFromCurrentPath(router);
  }

  ngOnInit(): void {
    this.clienteSubscription = this.userService.getClient(this.clienteId).subscribe({
      next:resp =>{
        this.clienteData = resp;        
        //this.clienteDispositivos = this.clienteData[0].devices;
        for(let i=0; i<this.clienteData[0].devices.length; i++){
          this.clienteDispositivos.push({
            id: this.clienteData[0].devices[i].id,
            dev_reference: this.clienteData[0].devices[i].dev_reference,
            dev_label: this.clienteData[0].devices[i].dev_label
          });
        }
        for(let i=0; i<this.clienteData[0].users.length; i++){
          this.clienteUsuarios.push({
            id: this.clienteData[0].users[i].id,
            email: this.clienteData[0].users[i].email,
          });
        }
        //this.clienteUsuarios = this.clienteData[0].users;
      },error:err =>{
        if (err.status == 429) {
          this.errorFinalMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorFinalMessage = err.error.message;
        }
      },complete: () =>{
        this.signin.patchValue({
          razonSocial: this.clienteData[0].razon_social,
          nombreComercial: this.clienteData[0].nombre_comercial,
          iniciales: this.clienteData[0].iniciales,
          telefono: this.clienteData[0].telefono,
          nif: this.clienteData[0].nif,
          personaContacto: this.clienteData[0].contacto,
          estado: this.clienteData[0].status
        });
        this.estado = this.clienteData[0].status;
        /*this.numeroDispositivos = this.clienteDispositivos.length;
        if(Math.floor(this.numeroDispositivos/2)==0){
          this.pageSizeOptions = [this.numeroDispositivos];
        } else {
          this.pageSizeOptions = [5, Math.floor(this.numeroDispositivos/2), this.numeroDispositivos];
        }
        this.numeroUsuarios = this.clienteUsuarios.length;
        if(Math.floor(this.numeroUsuarios/2)==0){
          this.pageSizeOptions1 = [this.numeroUsuarios];
        } else {
          this.pageSizeOptions1 = [5, Math.floor(this.numeroUsuarios/2), this.numeroUsuarios];
        }*/
        console.log(this.clienteDispositivos);
        console.log(this.clienteUsuarios);
        this.dataSource = new MatTableDataSource(this.clienteDispositivos);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const dataStr = this.displayedColumns
            .filter(key => key !== 'id')
            .map(key => data[key])
            .join('')
            .toLowerCase();
      
          return dataStr.includes(filter);
        };
        this.dataSource1 = new MatTableDataSource(this.clienteUsuarios);
        this.dataSource1.sort = this.sort1;
        this.dataSource1.paginator = this.paginator1;
      }
    })
  }

  ngAfterViewInit():void{
    /*this.dataSource = new MatTableDataSource(this.dispositivosEjemplo);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;*/
    /*this.dataSource1 = new MatTableDataSource(this.usuariosEjemplo);
    this.dataSource1.sort = this.sort1;
    this.dataSource1.paginator = this.paginator1;*/
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void { 
    if (this.clienteSubscription) {
      this.clienteSubscription.unsubscribe();
    } 
    if (this.editarSubscription) {
      this.editarSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }
  get razonSocialInput() { 
    return this.signin.get('razonSocial'); 
  }
  get nombreComercialInput() { 
    return this.signin.get('nombreComercial'); 
  }
  get inicialesInput() { 
    return this.signin.get('iniciales'); 
  }
  get nifInput() { 
    return this.signin.get('nif'); 
  }
  get telefonoInput() { 
    return this.signin.get('telefono'); 
  }
  get personaContactoInput() { 
    return this.signin.get('personaContacto'); 
  }

  //Función para buscar en la tabla
  applyFilterDatasource(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterDatasource1(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource1.filter = filterValue.trim().toLowerCase();
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  getClienteIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  get isPhoneNumberValid(): boolean {
    const phoneControl = this.telefonoInput;
    const phoneNumber = phoneControl?.value;
    // Si el número de teléfono está vacío, considerarlo válido
    if (!phoneNumber || phoneNumber.trim() === '') {
      return true;
    }
    const mask = '000 00 00 00'; // Formato utilizado en ngx-mask
    const requiredLength = mask.replace(/[^0]/g, '').length;
    
    return phoneNumber.replace(/[^0-9]/g, '').length === requiredLength;
  }

  validateDNI(dni:any) {
    var numero, x, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    if (dni?.length == 0 || dni == null) {
      return true;
    }
    dni = dni.toUpperCase();

    if(expresion_regular_dni.test(dni) === true){
        numero = dni.substr(0,dni.length-1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        x = dni.substr(dni.length-1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero+1);
        if (letra != x) {
            //alert('Dni erroneo, la letra del NIF no se corresponde');
            return false;
        }else{
            //alert('Dni correcto');
            return true;
        }
    }else{
        //alert('Dni erroneo, formato no válido');
        return false;
    }
  }

  guardarCliente(){
    //Error razonSocial vacio
    if(this.razonSocialInput?.value == ""){
      this.razonSocialError = true;
    } else{
      this.razonSocialError = false;
    }
    //Error nombre comercial vacio
    if(this.nombreComercialInput?.value == ""){
      this.nombreComercialError = true;
    } else{
      this.nombreComercialError = false;
    }
    //Error teléfono invalido o vacio
    if(this.isPhoneNumberValid){
      this.telefonoError = false;
    } else {
      this.telefonoError = true;
    }
    //Error nif
    if (this.validateDNI(this.nifInput?.value)){
      this.nifError=false;
    } else{
      this.nifError=true;
    }
    //Si no hay errores el cliente se crea correctamente
    if(this.razonSocialError == false && this.nombreComercialError == false && this.telefonoError == false && this.nifError==false){
      let client = { _method: "PATCH", cliente_id: this.clienteId, razon_social: this.razonSocialInput?.value, nombre_comercial: this.nombreComercialInput?.value, 
      iniciales: this.inicialesInput?.value, nif: this.nifInput?.value, contacto: this.personaContactoInput?.value, telefono: this.telefonoInput?.value, status: this.estado};
      this.editarSubscription = this.userService.updateClient(client).subscribe({
        next:resp => {
        }, error: err =>{
          this.errorFinalMessage = err.error.message;
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.clienteEditado=true;
            setTimeout(() => {
              this.clienteEditado = false;
              this.waitAfterSave = false;
            }, 3500);
          }
        }
      })
    }

    /*console.log("Razoón social: ", this.razonSocialInput?.value);
    console.log("Nombre comercial: ", this.nombreComercialInput?.value);
    console.log("Iniciales: ", this.inicialesInput?.value);
    console.log("Teléfono: ", this.telefonoInput?.value);
    console.log("Persona de Contacto: ", this.personaContactoInput?.value);
    console.log("Estado: ", this.estado);

    console.log('---------------------------------------');*/
  }

}
